// extracted by mini-css-extract-plugin
export default {"container":"tGrDJACbZXrQk1sCbJGHsA==","fader":"-4FJYAjz0mogwx6okvBuDw=="};